"use client"

type Navigation = { id: number; path: string; start: number; kind: "document" | "link" }
let navigation: Navigation | undefined = typeof window === "undefined" ? undefined : {
  id: 0, path: window.location.pathname + window.location.search, start: 0, kind: "document",
}
const reported = new Set<string>()

/** Link capture happens before App Router begins its server request. */
export function beginPageNavigation(path: string, search: string) {
  navigation = { id: (navigation?.id ?? 0) + 1, path: path + search, start: performance.now(), kind: "link" }
  reported.clear()
}

export function pageReadyTiming(area: string) {
  // Programmatic navigations without a start signal are omitted instead of
  // reporting the document's age as their load time. Refreshes do not repeat.
  if (!navigation || navigation.path !== window.location.pathname + window.location.search) return null
  const key = `${navigation.id}:${area}`
  if (reported.has(key)) return null
  reported.add(key)
  const duration = Math.round(performance.now() - navigation.start)
  const name = `setsail:${area}:ready`
  performance.clearMeasures(name)
  performance.measure(name, { start: navigation.start, duration })
  return { area, duration_ms: duration, navigation_type: navigation.kind }
}

export function performanceRoute(path: string) {
  return path.replace(/\/(accounts|companies|deals|rfps)\/[^/]+/g, "/$1/:id")
}
